export const highContrastTheme = {
  // Tablet breakpoint is used when in zoomed mode
  tablet: {
    menu: {
      textColor: '#000',
    },
    color: {
      grey: '#000',
      black: '#000',
      lightGrey: '#000',
    },
    stroke: {
      brand: '1px solid #000',
      light: '1px solid #000',
      dashed: '2px dashed #000',
      strong: '2px solid #000',
      default: '1px solid #000',
    },
    category: {
      textColor: '#000',
    },
    diningType: {
      pageTitleColor: '#000',
    },
    components: {
      SwitchGroup: {
        default: {
          selectedColor: '#000',
        },
      },
      Radio: {
        default: {
          hover: {
            iconColor: '#000',
          },
          selected: {
            iconColor: '#000',
          },
          unselected: {
            iconColor: '#000',
          },
        },
      },
      UserReward: {
        default: {
          titleColor: '#000',
          color: '#000',
        },
      },
      Separator: {
        default: {
          backgroundColor: '#000',
        },
      },
      Card: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        MealCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        MenuCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
        },
      },
      Text: {
        LoyaltyAuthCardLoggedIn: {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOut: {
          color: '#000',
        },
        'PointsRedemption:AfterExchanged:Note': {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOutSecondDescription: {
          color: '#000',
        },
      },
      Title: {
        default: {
          color: '#000',
        },
      },
      Button: {
        Link: {
          color: '#000',
        },
        Light: {
          color: '#000',
          borderColor: '#000',
        },
        Outline: {
          color: '#000',
          borderColor: '#000',
        },
      },
      Poster: {
        default: {
          Title: {
            color: '#000',
          },
        },
      },
      Sidebar: {
        default: {
          mode: 'dark',
          backgroundColor: '#000',
        },
      },
      ListCard: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        EmptyCard: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
      },
    },
  },
  kiosk: {
    menu: {
      textColor: '#000',
    },
    color: {
      grey: '#000',
      black: '#000',
      lightGrey: '#000',
    },
    stroke: {
      brand: '1px solid #000',
      light: '1px solid #000',
      dashed: '2px dashed #000',
      strong: '2px solid #000',
      default: '1px solid #000',
    },
    category: {
      textColor: '#000',
    },
    diningType: {
      pageTitleColor: '#000',
    },
    components: {
      SwitchGroup: {
        default: {
          selectedColor: '#000',
        },
      },
      Radio: {
        default: {
          selected: {
            iconColor: '#000',
          },
          unselected: {
            iconColor: '#000',
          },
        },
      },
      UserReward: {
        default: {
          titleColor: '#000',
          color: '#000',
        },
      },
      Separator: {
        default: {
          backgroundColor: '#000',
        },
      },
      Card: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        MealCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        MenuCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
        },
      },
      Text: {
        LoyaltyAuthCardLoggedIn: {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOut: {
          color: '#000',
        },
        'PointsRedemption:AfterExchanged:Note': {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOutSecondDescription: {
          color: '#000',
        },
      },
      Title: {
        default: {
          color: '#000',
        },
      },
      Button: {
        Link: {
          color: '#000',
        },
        Light: {
          color: '#000',
          borderColor: '#000',
        },
        Outline: {
          color: '#000',
          borderColor: '#000',
        },
      },
      Poster: {
        default: {
          Title: {
            color: '#000',
          },
        },
      },
      Sidebar: {
        default: {
          mode: 'dark',
          backgroundColor: '#000',
        },
      },
      ListCard: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        EmptyCard: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
      },
    },
  },
  largeScreenKiosk: {
    menu: {
      textColor: '#000',
    },
    color: {
      grey: '#000',
      black: '#000',
      lightGrey: '#000',
    },
    stroke: {
      brand: '1px solid #000',
      light: '1px solid #000',
      dashed: '2px dashed #000',
      strong: '2px solid #000',
      default: '1px solid #000',
    },
    category: {
      textColor: '#000',
    },
    diningType: {
      pageTitleColor: '#000',
    },
    components: {
      SwitchGroup: {
        default: {
          selectedColor: '#000',
        },
      },
      Radio: {
        default: {
          selected: {
            iconColor: '#000',
          },
          unselected: {
            iconColor: '#000',
          },
        },
      },
      UserReward: {
        default: {
          titleColor: '#000',
          color: '#000',
        },
      },
      Separator: {
        default: {
          backgroundColor: '#000',
        },
      },
      Card: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        MealCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        MenuCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
        },
      },
      Text: {
        LoyaltyAuthCardLoggedIn: {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOut: {
          color: '#000',
        },
        'PointsRedemption:AfterExchanged:Note': {
          color: '#000',
        },
        LoyaltyAuthCardLoggedOutSecondDescription: {
          color: '#000',
        },
      },
      Title: {
        default: {
          color: '#000',
        },
      },
      Button: {
        Link: {
          color: '#000',
        },
        Light: {
          color: '#000',
          borderColor: '#000',
        },
        Outline: {
          color: '#000',
          borderColor: '#000',
        },
      },
      Poster: {
        default: {
          Title: {
            color: '#000',
          },
        },
      },
      Sidebar: {
        default: {
          mode: 'dark',
          backgroundColor: '#000',
        },
      },
      ListCard: {
        default: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        EmptyCard: {
          Title: {
            color: '#000',
          },
          Footer: {
            LeftSide: {
              color: '#000',
            },
            RightSide: {
              color: '#000',
            },
          },
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
        UpsellCard: {
          Subtitle: {
            color: '#000',
          },
          Description: {
            color: '#000',
          },
        },
      },
    },
  },
};
